module.exports = __webpack_public_path__ + "static/media/truemoneywallet.73dcade6.jpg";